<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'"><a
        routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ROLE_USER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Shipments</li>
    </ol>
  </nav>
  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage2">{{errorMessage2}}</div>
  <div
    *ngIf=" ((totalCount > 0) && ( user.role === 'ROLE_USER' || user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT'))">
    <div class="row align-items-center">
      <div class="col-4"
           *ngIf="user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT' ||(user.role === 'ROLE_USER')">
        <ul class="list-inline tab-list">
          <div id="statusText1" class="invalid-feedback d-block" [hidden]="!statusText1">{{statusText1}}</div>
        </ul>
      </div>
    </div>
  </div>

  <div *ngIf="(user.role === 'ACCOUNT_OWNER' || user.role == 'DEMO_ACCOUNT' ||user.role === 'ROLE_USER') ">
    <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
    <div class="row align-items-center">
      <div class="col">
        <ul class="list-inline tab-list deskContent">
          <ng-container *ngFor="let om of ordersMainMenu">
            <li *ngIf="om.additional === 'N'" class="list-inline-item">
              <a (click)="populateTabData(om.tabClicked,om.orderStatus);resetCheckedList(); tabChange()"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
          </ng-container>
        </ul>
        <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
                [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
          <option *ngFor="let u of ordersMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
        </select>
      </div>
      <div class="col text-right">
        <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                class="btn btn-outline-primary btn-sm dropdown-toggle ml-2 d-none-mobile"
                *ngIf="(checkedList2?.length) && tabClicked !== 'all'">
          Actions
        </button>
        <div class="dropdown-menu dropdown-menu2  dropdown-menu-right"
             *ngIf="(checkedList2?.length) && tabClicked !== 'all'">
          <a *ngIf="tabClicked === 'submitted'" (click)="generateManifest(checkedOrderIdList)"
             class="dropdown-item file btn shift-import">Generate Manifest</a>
          <a *ngIf="tabClicked === 'submitted'" (click)="generateShippingLabel(shipments)"
             class="dropdown-item file btn shift-import">Generate Shipping Label</a>
          <a *ngIf="tabClicked === 'submitted'" (click)="cancelOrderPopUp(shipments)"
             class="dropdown-item file btn shift-import">Cancel Shipment</a>
          <a *ngIf="tabClicked === 'submitted'" (click)="holdOrderPopUp(shipments)"
             class="dropdown-item file btn shift-import">Mark as On Hold</a>
        </div>
        <a placement="bottom" ngbTooltip="Create" class="ml-2">
          <svg xmlns="http://www.w3.org/2000/svg" (click)="submitOrder()" width="30" height="30" viewBox="0 0 30 30">
            <defs>
              <style>.a {
                fill: #8a55bb;
              }

              .b {
                fill: #fff;
              }</style>
            </defs>
            <g transform="translate(4 2.5)">
              <rect class="a" width="30" height="30" rx="3" transform="translate(-4 -2.5)"/>
              <path class="b"
                    d="M8.563.563a8,8,0,1,0,8,8A8,8,0,0,0,8.563.563Zm4.645,8.9a.388.388,0,0,1-.387.387H9.853v2.968a.388.388,0,0,1-.387.387H7.659a.388.388,0,0,1-.387-.387V9.853H4.3a.388.388,0,0,1-.387-.387V7.659A.388.388,0,0,1,4.3,7.272H7.272V4.3a.388.388,0,0,1,.387-.387H9.466a.388.388,0,0,1,.387.387V7.272h2.968a.388.388,0,0,1,.387.387Z"
                    transform="translate(2.823 3.938)"/>
            </g>
          </svg>
        </a>
      </div>
    </div>
  </div>

  <div class="row"
       [hidden]="(user.role === 'ACCOUNT_OWNER' ||user.role === 'DEMO_ACCOUNT' ||user.role === 'ROLE_USER') ">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table id="tables_id" class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" width="100%">
          <thead>
          <tr>
            <th>
            </th>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th style="width=150px; !important">Shipment Date</th>
            <th>Channel / Source</th>
            <th>Age of shipment</th>
            <th>Payment Method</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of shipments">
            <td>
              <div class="form-checkbox" [hidden]="tabClicked == 'all'"><input type="checkbox"
                                                                               id="{{o.shipmentHeaderId}}"
                                                                               [(ngModel)]="o.isSelected"
                                                                               name="list_name"
                                                                               (change)="selectShip(o)">
                <label for="{{o.shipmentHeaderId}}"></label></div>
            </td>
            <td><a routerLink="/admin/viewShipments/{{o.shipmentHeaderId}}">{{o.sourceOrderNumber}}</a></td>
            <td>{{o.sourceOrderId || '--'}}</td>
            <td style="width=150px; !important">{{(o.createdDate) | date: 'dd-MMM-yyyy'}}</td>
            <td>{{(o.connectionName ? (o.connectionName + '/') : '') | titlecase}}{{o.channelName | replaceStatus}}</td>
            <td>{{o.noOfDaysOnHold}}</td>
            <td>{{(o?.paymentMethod | replaceStatus) || '--'}}</td>
            <td>
              <div class="text-truncate" title="{{(o.status == 'READY_TO_SHIP' ? 'Carrier to be assigned':
                (o.status == 'SHIPPED' ? 'Shipped':
                (o.status == 'AWAITING_CARRIER' ? 'Awaiting Carrier':
                (o.status == 'IN_TRANSIT' ? 'In Transit':
                (o.status == 'GENERATE_LABEL' ? 'Generate Label':
                (o.status == 'LABEL_GENERATED' ? 'Label Generated': o.status )))))) | replaceStatus}}"
                   style="width:100px;">{{(o.status == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                (o.status == 'SHIPPED' ? 'Shipped' :
                  (o.status == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                    (o.status == 'IN_TRANSIT' ? 'In Transit' :
                      (o.status == 'GENERATE_LABEL' ? 'Generate Label' :
                        (o.status == 'LABEL_GENERATED' ? 'Label Generated' : o.status)))))) | replaceStatus}}
              </div>
            </td>
            <td>
              <div
                *ngIf="(o.status == 'READY_TO_SHIP' || o.status == 'GENERATE_LABEL' || o.status == 'LABEL_GENERATED'|| o.status == 'SHIPPED') && o.thirdPartyTrackingNum !== null">
                <a routerLink="/trackOutboundOrder/{{o.shipmentHeaderId}}/{{o.jhiUserId}}" target="_blank">
                  <img src="assets/images/dsBuffer.png" width="30" height="30" alt="trackImage">
                </a>
              </div>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="shipments?.length===0|| !shipments?.length">
            <td colspan="8" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
      <div class="inner-box d-block d-sm-none ">
        <table id="Table_id" class="table tablesaw tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order #</th>
            <th>Channel Order #</th>
            <th width="200px;" style="width: 0px!important;">Shipment Date</th>
            <th>Channel / Source</th>
            <th width="200px;">Contact</th>
            <th>City</th>
            <th style="width: 102px;">Age of Shipment</th>
            <th *ngIf="user.role==='ACCOUNT_OWNER'" style="width:110px!important;">Payment Method</th>
            <th>Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let o of shipments">
            <td>
              <b class=" tablesaw-cell-label">Order #</b>
              <span class="tablesaw-cell-content">
                 <a routerLink="/admin/viewShipments/{{o.shipmentHeaderId}}"
                    [ngClass]="{'disabled':(user.role === 'ROLE_USER' && !accessSec.editOrder)}">{{o.sourceOrderNumber}}</a></span>
            </td>
            <td><b class=" tablesaw-cell-label">Source Order</b><span class="tablesaw-cell-content"> {{o.sourceOrderId || '--'}}</span></td>
            <td><b class=" tablesaw-cell-label">Source Data</b><span class="tablesaw-cell-content">  {{(o.createdDate) | date: 'dd-MMM-yyyy'}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Channel Name</b>
              <span
                class="tablesaw-cell-content"> {{(o.connectionName ? (o.connectionName + '/') : '') | titlecase}}{{o.channelName | titlecase}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Contact Name</b>
              <span
                class="tablesaw-cell-content">  {{o.contactCompanyName ? (o.contactCompanyName + '-') : ''}}{{o.contactName}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">City</b>
              <span class="tablesaw-cell-content">{{o.contactCity  | replaceStatus}}</span></td>
            <td><b class=" tablesaw-cell-label">Age Of Address</b>
              <span class="tablesaw-cell-content">{{o.noOfDaysOnHold}}</span></td>
            <td *ngIf="user.role==='ACCOUNT_OWNER'"><b class=" tablesaw-cell-label">Payment Method</b>
              <span class="tablesaw-cell-content">{{(o?.paymentMethod|replaceStatus) || '--'}}</span></td>
            <td><b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">
                <div class="text-truncate" title="{{(o.status == 'READY_TO_SHIP' ? 'Carrier to be assigned':
                  (o.status == 'SHIPPED' ? 'Shipped':
                  (o.status == 'AWAITING_CARRIER' ? 'Awaiting Carrier':
                  (o.status == 'IN_TRANSIT' ? 'In Transit':
                  (o.status == 'GENERATE_LABEL' ? 'Generate Label':
                  (o.status == 'LABEL_GENERATED' ? 'Label Generated': o.status )))))) |replaceStatus}}"
                     style="width:100px;">{{(o.status == 'READY_TO_SHIP' ? 'Carrier to be assigned' :
                  (o.status == 'SHIPPED' ? 'Shipped' :
                    (o.status == 'AWAITING_CARRIER' ? 'Awaiting Carrier' :
                      (o.status == 'IN_TRANSIT' ? 'In Transit' :
                        (o.status == 'GENERATE_LABEL' ? 'Generate Label' :
                          (o.status == 'LABEL_GENERATED' ? 'Label Generated' : o.status)))))) |replaceStatus}}
                </div>
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<!--Tracking Details popup-->
<div class="modal fade" id="orderDetails" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!--Header-->
      <div class="modal-header">
        <h2 class="modal-title">Tracking Details</h2>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <!--Body-->
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <div [hidden]="awb.tracking_data.error==null">
              <label class="text-black"><b>Info :</b><span class="ml-1">{{awb.tracking_data.error}}</span></label><br>
            </div>
            <div [hidden]="awb.tracking_data.error!=null">
              <label class="text-black"
                     *ngFor="let s of awb.tracking_data.shipment_track_activities"><b>Activity:</b><span
                class="ml-1">{{s.activity}}</span></label><br>
              <div *ngFor="let s of awb.tracking_data.shipment_track">
                <label class="text-black"><b> Delivered to :</b><span class="ml-1">{{s.delivered_to}}</span></label><br>
                <label class="text-black"><b>Status :</b><span class="ml-1"></span>{{s.current_status}}</label><br>
              </div>
              <label class="text-black"><b>Estimated Delivery date :</b><span
                class="ml-1">{{awb.tracking_data.edd | date : "dd-MMM-yyyy"}}</span></label>
            </div>
          </div>
        </div>
      </div>
      <!--Footer-->
    </div>
  </div>
</div>

<div [ngStyle]="{'display': cancelActivities =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': cancelActivities == 'Y'}" class="modal" id="popUpAssign" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleDriverModalPreviewLabel">Cancel Shipment</h5>
        <button type="button" class="close" (click)="closePopUp()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="row">
                <div class="col">
                  <label class="control-label" for="cancelReason">Cancel Reason</label>
                  <select id="cancelReason" class="form-control" [(ngModel)]="reason"
                          [ngModelOptions]="{standalone: true}" required>
                    <option *ngFor="let c of cancelReasons" [ngValue]="c.config">{{c.config}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closePopUp()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="cancelMultiOrders(shipments)">Ok</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': holdActivities =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': holdActivities == 'Y'}" class="modal" id="popUpHold" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog snk-modal-dialog-45 modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleHoldLabel">Shipments to put on Hold</h5>
        <button type="button" class="close" (click)="closePopUpHold()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row mt-3">
            <div class="col">
              <div class="d-none d-sm-block">
                <div calss="row">
                  <div calss="col">
                    <table class="table">
                      <thead>
                      <tr>
                        <th>Channel Order #</th>
                        <th>Shipment Date</th>
                        <th>Contact</th>
                        <th>Warehouse</th>
                        <th>Action</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let l of checkedListView;let i=index">
                        <td>{{l.sourceOrderId}}</td>
                        <td>{{l.orderedDate}}</td>
                        <td style="text-transform:capitalize;">{{l.contactCompanyName}}-{{l.contactName}}</td>
                        <td>{{l.warehouseName}}</td>
                        <td>
                          <a (click)="splice(i,l.shipmentHeaderId)">
                            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" height="21" viewBox="0 0 18.877 24.27">
                              <defs>
                                <style>.a {
                                  fill: #848484;
                                }
                                </style>
                              </defs>
                              <path class="a"
                                    d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                                    transform="translate(-7.5 -4.5)"/>
                            </svg>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <label class="control-label" for="hold">Hold Reason</label>
                  <div class="form-group mt-2">
                    <textarea type="text" id="hold" [(ngModel)]="activityDetails" class="form-control"
                              [ngModelOptions]="{standalone: true}" required></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-md-12 text-right">
              <button type="submit" class="btn btn-cancel ml-1" (click)="closePopUpHold()">Cancel</button>
              <button type="submit" class="btn btn-orange ml-1" (click)="holdMultiOrders(shipments)">Ok</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div [ngStyle]="{'display': pdfGenerate =='Y'? 'block' : 'none'}" style="overflow-y:auto"
     [ngClass]="{'modal': pdfGenerate == 'Y'}" class="modal" id="popupShippingLabel" tabindex="-1" role="dialog"
     aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content pl-4 pr-4 pt-2 pb-2">
      <div class="modal-header border-0">
        <h5 class="modal-title w-100" id="exampleShippingLabel">Choose Print Option</h5>
        <button type="button" id="enterQuantity" class="close" (click)="close()" aria-label="Close">
          <svg id="close-icon" xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
            <g id="Close-Icon-2" data-name="Close-Icon" transform="translate(16.263 0) rotate(45)">
              <path id="Line_4" data-name="Line 4" d="M1,0V22" transform="translate(10.5 0.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
              <path id="Line_6" data-name="Line 6" d="M0,1H22" transform="translate(0.5 10.5)" fill="none"
                    stroke="#979797" stroke-linecap="square" stroke-miterlimit="10" stroke-width="1"/>
            </g>
          </svg>
        </button>
      </div>
      <div class="modal-body snk-modal-body">
        <form>
          <div class="row">
            <div class="col-8">
              <div class="form-group required">
                <!--                <label class="control-label" for="printSize2">Print Size Option</label>-->
                <select class="form-control" id="printSize2" [(ngModel)]="size" [ngModelOptions]="{standalone: true}"
                        [ngClass]="{'is-invalid':sizeError}" required>
                  <option value="Custom">Label Printer (101mm X 150mm)</option>
                </select>
                <div class="invalid-feedback d-block shift-invalid-login" [hidden]="!sizeError">{{sizeError}}</div>
              </div>
            </div>
            <div class="col-4 text-right">
              <button type="submit" class="btn btn-orange ml-1" (click)="printShipment()">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
